import { apiClient, ApiClientResponse } from '../services/api-client';

export const CLIENT_IDENTITY_DOCUMENT_TYPE = 'clientIdentityDocument';

export const CLIENT_IDENTITY_DOCUMENT_MAX_FILE_BYTES = 10_485_760;

export function isClientIdentityDocumentFileTooLarge(fileSizeBytes: number): boolean {
  return fileSizeBytes > CLIENT_IDENTITY_DOCUMENT_MAX_FILE_BYTES;
}

export type ClientIdentityDocumentMedia = {
  _id: string;
  createdAt: string;
  name: string;
};

type MediaListPayload = ClientIdentityDocumentMedia[] | { data: ClientIdentityDocumentMedia[] };

function extractMediaList(payload: MediaListPayload | undefined): ClientIdentityDocumentMedia[] {
  if (!payload) {
    return [];
  }

  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload.data)) {
    return payload.data;
  }

  return [];
}

export default {
  listClientIdentityDocuments: (transactionId: string): Promise<ApiClientResponse<ClientIdentityDocumentMedia[]>> =>
    apiClient
      .get<MediaListPayload>('/media', {
        params: {
          ref: transactionId,
          type: CLIENT_IDENTITY_DOCUMENT_TYPE,
        },
      })
      .then((response) => {
        if (!response.ok) {
          return {
            ...response,
            data: [] as ClientIdentityDocumentMedia[],
          };
        }

        return {
          ...response,
          data: extractMediaList(response.data),
        };
      }),
  uploadClientIdentityDocument: (
    transactionId: string,
    file: File,
  ): Promise<ApiClientResponse<ClientIdentityDocumentMedia>> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', CLIENT_IDENTITY_DOCUMENT_TYPE);
    formData.append('ref', transactionId);

    return apiClient.post('/media', formData);
  },
};
